export const PDF_DOCUMENT_DEFAULT_WIDTH = 612;
export const PDF_DOCUMENT_DEFAULT_HEIGHT = 792;
